import React, { PropTypes } from 'react'
import Truncate from 'react-truncate'
import { sample } from 'lodash'
import { Link } from 'react-router'

import './SearchResult.scss'
import AliadaProfileCard from 'components/AliadaProfileCard'

const SearchResult = ({ booking, aliada, aliadaProfileUrl, changeAliadaUrl }) => {
  function hasPositiveComments (aliada) {
    const MINIMUM_RATING_VALUE = 4
    return aliada.ratings.some(rating => rating.value >= MINIMUM_RATING_VALUE)
  }

  function getLatestPositiveComment (aliada) {
    const MINIMUM_RATING_VALUE = 4
    const FIRST_COMMENT = 0

    const latestPositiveComment = aliada.ratings
                                    .filter(rating => rating.value >= MINIMUM_RATING_VALUE)
                                    .map(rating => rating.comment)[FIRST_COMMENT]

    return `“${latestPositiveComment}”`
  }

  function getTrustMessage (aliada) {
    const messages = [
      `${aliada.firstName} pasó por los más estrictos filtros para prestar sus servicios en la plataforma.`,
      `Verificamos y resguardamos los datos de ${aliada.firstName} para nunca tengas que preocuparte. `,
      `${aliada.firstName} pasó por exámenes psicométricos, para asegurarnos que sólo personas confiables pertenecen a la comunidad.`,
      `${aliada.firstName}, cómo todas las Aliadas, es calificada por sus clientes para mantener la calidad del servicio.`
    ]

    let message = sample(messages)

    if (process.env.NODE_ENV === 'test') {
      message = messages[0]
    }

    return (
      <span>{message}</span>
    )
  }

  return (
    <div className='SearchResult'>
      <AliadaProfileCard
        aliada={aliada}
        estimatedServiceHours={booking.estimatedHours}
        />
      <p className='SearchResultItem-review'>
        <Truncate lines={3} ellipsis='…”'>
          {hasPositiveComments(aliada)
            ? getLatestPositiveComment(aliada)
            : getTrustMessage(aliada)
          }
        </Truncate>
      </p>
      <div className='SearchResult-buttons'>
        <Link
          className='SearchResult-viewProfileButton btn btn-default btn-block btn-lg'
          to={aliadaProfileUrl}
          >
          Ver perfil
        </Link>

        <div className='SearchResult-buttonsSpacer' />

        <Link
          className='SearchResult-reserveButton btn btn-primary btn-block btn-lg'
          to={changeAliadaUrl}
          >
          Reservar
        </Link>
      </div>
    </div>
  )
}

SearchResult.displayName = 'SearchResult'
SearchResult.propTypes = {
  aliada: PropTypes.object.isRequired,
  booking: PropTypes.object.isRequired,
  aliadaProfileUrl: PropTypes.string.isRequired,
  changeAliadaUrl: PropTypes.string.isRequired
}

export default SearchResult



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/ChangeAliadaSearchBase/components/SearchResult/SearchResult.js